export class FloatHistory {
  docId?: string;
  amount: number;
  previousFloat: number;
  currentFloat: number;
  credits: number;
  clientCode: string;
  resellerCode: string;
  type?: string;
  note: string;
  doneBy?: string;
  doneByEmail?: string;
  actionDate?: any;
}

export class SmsHistory {
  docId?: string;
  smses: number;
  previousSmsCredits: number;
  currentSmsCredits: number;
  clientCode: string;
  resellerCode: string;
  type?: string;
  note: string;
  doneBy?: string;
  doneByEmail?: string;
  actionDate?: any;
}

export class SmsCreditsHistory {
  docId?: string;
  amount: number;
  previousCredits: number;
  currentCredits: number;
  credits: number;
  clientCode: string;
  resellerCode: string;
  type?: string;
  rate: number;
  note: string;
  doneBy?: string;
  doneByEmail?: string;
  actionDate?: any;
}
